// GS Group – Yard Management web theme.
// Mirrors the mobile theme (Georgia serif, industrial slate + blue palette).
export const colors = {
  surface: "#F8FAFC",
  onSurface: "#0F172A",
  surfaceSecondary: "#FFFFFF",
  surfaceTertiary: "#E2E8F0",
  onSurfaceTertiary: "#334155",
  surfaceInverse: "#0F172A",
  onSurfaceInverse: "#F8FAFC",
  brand: "#1E293B",
  brandPrimary: "#1D4ED8",
  onBrandPrimary: "#FFFFFF",
  brandSecondary: "#3B82F6",
  brandTertiary: "#DBEAFE",
  onBrandTertiary: "#1E3A8A",
  success: "#166534",
  onSuccess: "#F0FDF4",
  warning: "#C2410C",
  onWarning: "#FFF7ED",
  error: "#991B1B",
  onError: "#FEF2F2",
  info: "#075985",
  onInfo: "#F0F9FF",
  border: "#CBD5E1",
  borderStrong: "#94A3B8",
  divider: "#E2E8F0",
  accent: "#E2581B",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48,
};

export const SERIF = "Georgia, 'Times New Roman', Times, serif";

// Font style presets (serif everywhere; bold via fontWeight).
export const fonts = {
  display: { fontFamily: SERIF, fontWeight: 700 },
  displayRegular: { fontFamily: SERIF, fontWeight: 400 },
  mono: { fontFamily: SERIF, fontWeight: 400 },
  monoBold: { fontFamily: SERIF, fontWeight: 700 },
};
